import React, { useState, useEffect  } from 'react'
import {
  Row,
  Col,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useSelector } from "react-redux";
import EvalComparisonWordPred from './EvalComparisonWordPred'
import EvalComparisonWordSeikai from './EvalComparisonWordSeikai'

// EvalComparisonRow
const EvalComparisonRow = (props) => {

  let [pairList, setPairList] = useState([]);

  // componentDidMount
  useEffect(() => {

    let _pairListRow = props.pairListRow

    for (let i=0; i<_pairListRow.length; i++) {
      _pairListRow[i].localidx = i
    }

    setPairList(_pairListRow)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.pairListRow]);

  // toggle pair status
  let _updatePairStatus = (item, status) => {

    let _pairList = pairList

    // props.updatePairList(item.globalidx, _pairList[item.localidx])
    props.updatePairList({
      globalidx: item.globalidx,
      prediction: null,
      status: status,
    })
  }


  // update word type
  let _updateWordType = (item, _wordType) => {

    props.updateWordType({
      globalidx: item.globalidx,
      wordType: _wordType,
    })
  }



  // _swapWords
  let _swapWords = (fromItem, toItem) => {

    let _from_prediction = fromItem.prediction
    let _to_prediction = toItem.prediction

    // update
    props.updatePairList({
      globalidx: fromItem.globalidx,
      prediction: _to_prediction,
      status: null,
    })

    props.updatePairList({
      globalidx: toItem.globalidx,
      prediction: _from_prediction,
      status: null,
    })
  }

  // _swapSeikai _swapWords is actually swap predictions
  let _swapSeikai = (fromItem, toItem) => {

    let _from_seikai = fromItem.seikai
    let _to_seikai = toItem.seikai

    // update
    props.updatePairListSeikai({
      globalidx: fromItem.globalidx,
      seikai: _to_seikai,
      status: null,
    })

    props.updatePairListSeikai({
      globalidx: toItem.globalidx,
      seikai: _from_seikai,
      status: null,
    })
  }


  return (
    <Row style={{
      marginTop: 20,
      marginBottom: 20,
      paddingBottom: 20,
      borderBottomStyle: 'solid',
      borderBottomWidth: 1,
      borderBottomColor: '#cccc',
    }}>

      <Col>
        <div style={{
          display: 'inline-block',
          textAlign: 'center',
        }}>
          <span style={{
              color: '#000000',
              padding: 6,
              margin: 6,
              marginLeft: 8,
              marginRight: 8,
            }}>
              正解
            </span>
          <br />
          <br />
          <span style={{
            color: '#000000',
            padding: 6,
            margin: 6,
            marginLeft: 8,
            marginRight: 8,
          }}>
            予測
          </span>
        </div>


        {pairList && pairList.map((item, idx1) => (

          <div key={item.seikai+item.prediction+idx1+item.status} style={{
            display: 'inline-block',
            textAlign: 'center',
          }}>

            <EvalComparisonWordSeikai
              accountType={props.accountType}
              swapSeikai={_swapSeikai}
              updateWordType={_updateWordType}
              item={item} />

            <br />
            <br />

            <EvalComparisonWordPred
              accountType={props.accountType}
              swapWords={_swapWords}
              updatePairStatus={_updatePairStatus}
              item={item} />
          </div>
        ))}

      </Col>

    </Row>
  )
}

export default EvalComparisonRow
